<div class="editorContainer">
    <div class="div-editor" #editorZone></div>
</div>
